module.exports = __webpack_public_path__ + "img/avatar_outer_box2.2243345c.png";